import React from 'react';
import { Box, Typography } from '@mui/material';
import { AddressFields } from '../types';

interface AddressDisplayProps {
  address?: AddressFields & { address?: string };
  fallbackAddress?: string;
}

const AddressDisplay: React.FC<AddressDisplayProps> = ({ address, fallbackAddress }) => {
  if (!address) {
    return <Typography variant="body1">{fallbackAddress || '-'}</Typography>;
  }

  const { postal_code, prefecture, city, street, building } = address;
  const hasStructured = prefecture || city || street;

  if (hasStructured) {
    return (
      <Box>
        {postal_code && (
          <Typography variant="body2" color="text.secondary">
            〒{postal_code}
          </Typography>
        )}
        <Typography variant="body1">
          {[prefecture, city, street].filter(Boolean).join('')}
          {building && ` ${building}`}
        </Typography>
      </Box>
    );
  }

  return (
    <Typography variant="body1">
      {address.address || fallbackAddress || '-'}
    </Typography>
  );
};

export default AddressDisplay;
